// extracted by mini-css-extract-plugin
export default {"Icons":"Icons_VP4L7","Space":"Space_XcUse"};